const testingCenters = [
  {
    vis_id: 1,
    location: "Ojodu",
    address: "VIS Testing Ground, Ogunnusi Road, Ojodu - Berger, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 2,
    location: "Oko-Oba",
    address:
      "VIS Office, 1 Palm-View Estate, Suco Bus-stop, Opposite RRS Command, Oko-Oba, Agege, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 3,
    location: "Ayobo",
    address:
      "VIS Office, Falola street, Majiyagbe layout, Church busstop, Ipaja, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 4,
    location: "PWD",
    address: "VIS Office, Work yard, Old secretariat, Ikeja, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 5,
    location: "Lagos Island",
    address: "VIS Yard Olowu Street, Lagos Island",
    description: "Testing for cars only",
  },
  {
    vis_id: 6,
    location: "Agric Isawo",
    address:
      "VIS Office, Beside Rehabilitation Vocational Centre, Oremeji Taylor Close, Off Isawo/Owutu Road, Ikorodu West, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 7,
    location: "Bolade Oshodi",
    address: "Safety Arena, Bolade Oshodi, Behind Bolade Market, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 8,
    location: "Epe",
    address:
      "VIS Work Yard, After T-Junction, Opposite Epe Resort& Spa, Epe Itoki Express Way, Epe Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 9,
    location: "Gbagada",
    address: "VIS Office, NCI Gbagada Lagos, Beside Floor Mill, Gbagada Lagos",
    description: "Testing for cars & trucks available",
  },
  {
    vis_id: 10,
    location: "Ajah",
    address: "VIS Zone Office, Ilaje Road, Ajah Eti Osa",
    description: "Testing for cars only",
  },
  {
    vis_id: 11,
    location: "Cele",
    address: "Itire-Ikate LCDA Office Annex, by Cele Bus Stop, Lagos ",
    description: "Testing for cars only",
  },
  {
    vis_id: 12,
    location: "Ibeju Lekki",
    address:
      "Behind Ibeju-Lekki LG Secretariat, Igango Olopa, Lekki Epe Express, Lagos",
    description: "Testing for cars & trucks available",
  },
  {
    vis_id: 13,
    location: "Alausa",
    address: "Assbifi Road, beside Passport Office, Alausa CBD, Ikeja, Lagos ",
    description: "Testing for cars only",
  },
  {
    vis_id: 14,
    location: "Odongunyan",
    address: "VIS Office, Odogunyan by Olopomeji bus-stop, Ikorodu,Lagos",
    description: "Testing for cars & trucks available",
  },
  {
    vis_id: 15,
    location: "Oko Afo",
    address: "VIS Office, LASTMA Bus-stop, Badagry express way, Oko-Afo Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 16,
    location: "Badagry",
    address: "VIS Office, PWD Yard, Hospital Road, Badagry town, Badagry Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 17,
    location: "Ojota",
    address:
      "Mechanic Village Workshop, beside Olushosun Dumoing Site, Ojota bus/stop, Lagos",
    description: "Testing for cars & trucks available",
  },
  {
    vis_id: 18,
    location: "Yaba",
    address: "8, Edmond Crescent Jibowu Yaba, Yaba, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 19,
    location: "Agbowa",
    address: "Behind Agbowa LCDA, VIO New building, Ota Road, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 20,
    location: "Anthony",
    address:
      "VIS Testing Ground, Ikorodu Road, by Anthony Bus Stop, Anthony, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 21,
    location: "Oke Odo",
    address: "24/26 Old Otta Road, Ile Epo, Oke Odo, Alimosho, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 22,
    location: "Suru Alaba",
    address: "4, Asemota Street, Alaba, Ojo, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 23,
    location: "Coker Aguda",
    address: "4, Ishola Street, Off Randle Avenue, Ojuelegba, Surulere",
    description: "Testing for cars only",
  },
  {
    vis_id: 24,
    location: "LASU",
    address: "Iyana Iba Bus stop, Ojo Campus Badagry Express Way, Ojo",
    description: "Testing for cars only",
  },
  {
    vis_id: 25,
    location: "UNILAG",
    address: "Opposite Unilag Mosque, Yaba, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 26,
    location: "Omorege",
    address: "4, Asemota Street, Alaba Ojo, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 27,
    location: "Owode Onirin",
    address: "Owode Onirin Bus Stop, Ikorodu Road, Lagos",
    description: "Testing for cars only",
  },
  {
    vis_id: 28,
    location: "Mobile Station",
    address: "Eti-Osa Testing Ground MMA Lucy Akpabio Street, Victoria Island",
    description: "Testing for cars only",
  },
  {
    vis_id: 29,
    location: "Daleko",
    address:
      "Olu Aina Street Off Oye Round about Isolo Road, Opp Lagos Homs By Water Works Mushin, Lagos ",
    description: "Testing for cars only",
  },
  {
    vis_id: 30,
    location: "Lakowe",
    address: "Lakowe School Gate Bus Stop, Lakowe Ibeju Lekki ",
    description: "Testing for cars only",
  },
]

module.exports = { testingCenters }
